var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrashicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.98876 0C6.36914 0 5.05618 1.3215 5.05618 2.95166V3.05344H1.92135H0.910113C0.407468 3.05344 0 3.46355 0 3.96947C0 4.47537 0.407468 4.8855 0.910113 4.8855H1.92135H2.23366L3.06834 17.3756L3.06847 17.3776C3.16102 18.8518 4.37599 20 5.84383 20H12.1562C13.624 20 14.8389 18.8518 14.9315 17.3777L14.9316 17.3756L15.7664 4.8855H16.0787H17.0899C17.5926 4.8855 18 4.47537 18 3.96947C18 3.46355 17.5926 3.05344 17.0899 3.05344H16.0787H12.9438V2.95166C12.9438 1.3215 11.6308 0 10.0112 0H7.98876ZM11.1236 3.05344H6.87641V2.95166C6.87641 2.33331 7.37443 1.83206 7.98876 1.83206H10.0112C10.6256 1.83206 11.1236 2.33331 11.1236 2.95166V3.05344ZM7.58346 8.00149C7.56192 7.49604 7.1374 7.10386 6.63519 7.12552C6.13301 7.14718 5.74336 7.57449 5.76488 8.07989L6.06825 15.2046C6.08977 15.71 6.51432 16.1023 7.01645 16.0806C7.51863 16.0589 7.90837 15.6317 7.88683 15.1262L7.58346 8.00149ZM12.2351 8.07989C12.2567 7.57449 11.867 7.14718 11.3648 7.12552C10.8626 7.10386 10.4381 7.49604 10.4165 8.00149L10.1132 15.1262C10.0916 15.6317 10.4814 16.0589 10.9835 16.0806C11.4857 16.1023 11.9102 15.71 11.9318 15.2046L12.2351 8.07989Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashicon);
export default __webpack_public_path__ + "static/media/trashicon.35c3af64.svg";
export { ForwardRef as ReactComponent };